import { nextTick } from '@vue/composition-api'

export const useDOMPageTitle = () => {
  const setDOMPageTitle = async (title) => {
    await nextTick()

    document.title = `LimeIQ - ${title}`
  }

  return {
    setDOMPageTitle
  }
}
